<ng-container>
  <h2>Generate Barcode for the following input</h2>
  <input [(ngModel)]="barcodeValue" placeholder="Barcode content" />
  <button (click)="generateBarcode()">Generate</button>
</ng-container>
<section>
  <div #barcodeContainer class="barcode-wrapper">
    <svg #barcode></svg>
  </div>
  <button (click)="downloadBarcode()">Download Barcode as PNG</button>
</section>
<hr>
<br />
<hr>
<ng-container>
  <h2>Generate QR Code for the following input</h2>
  <input [(ngModel)]="qrData" placeholder="QR content" />
</ng-container>

<section>
  <div #qrContainer class="qr-wrapper">
    <qrcode [qrdata]="qrData" [width]="256"></qrcode>
  </div>
  <button (click)="downloadQR()">Download QR as PNG</button>
</section>





